export default __webpack_public_path__ + "static/media/ThreadingImg.55c24bef.jpg";